module.exports = __webpack_public_path__ + "media/images/favicon/android-chrome-512x512-d9c68cc84821b89a294828273ab683cf.png";